import React, { Children, useEffect, useRef, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Swal from "sweetalert2";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { HelpCircle, MessageSquare, Bell } from "lucide-react";
import LOCAL_KEYS, {
  parseLocalStorageJSON,
} from "../../../helpers/localstorage";
import { SidebarContext } from "../SidebarContext";
import { UserContext } from "../../../Context/User";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { red } from "@mui/material/colors";
import { LoginContext } from "../../../Context/Auth";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const profileRef = useRef(null);
  const { isExpanded, toggleSidebar } = useContext(SidebarContext);
  const { currentUserDetails } = useContext(UserContext);
  const { getProfilePhoto } = useContext(LoginContext);

  // const getProfilePhoto = () => {
  //   // Get the first character of first and last name to determine an image number (for consistent results)
  //   const firstInitial = currentUserDetails?.firstName?.charAt(0)?.toLowerCase() || 'a';
  //   const lastInitial = currentUserDetails?.lastName?.charAt(0)?.toLowerCase() || 'b';
  //   const charCode1 = firstInitial.charCodeAt(0) || 97; // 'a' is 97
  //   const charCode2 = lastInitial.charCodeAt(0) || 98;  // 'b' is 98
    
  //   // Generate a gender and image number based on the user's name (for consistent results)
  //   const gender = (charCode1 % 2 === 0) ? 'men' : 'women';
  //   const imageNumber = ((charCode1 + charCode2) % 70) || 1; // RandomUser has ~70 images per category
    
  //   return {
  //     src: `https://randomuser.me/api/portraits/${gender}/${imageNumber}.jpg`,
  //     fallback: `https://ui-avatars.com/api/?name=${currentUserDetails?.firstName || ''}+${currentUserDetails?.lastName || ''}&background=2563EB&color=FFFFFF`
  //   };
  // };
  const profileDetails = parseLocalStorageJSON(LOCAL_KEYS.PROFILE_DETAILS);
  console.log(profileDetails,"check profile details");
  
  // Use consistent profile photo

  
  //const { expandMenuBar } = appConfigState;
  
  const menu = [
    {
      name: "Profile",
      path: "/profile-update",
      icon: <PermIdentityIcon fontSize="small" />,
      children: false,
    },
    {
      name: "Settings",
      path: "/updatePassword",
      icon: <SettingsIcon fontSize="small" />,
    },
    {
      name: "Logout",
      path: "logout",
      icon: <LogoutIcon fontSize="small" sx={{ color: red[500] }} />,
    },
  ];

  const AdminNavigation = [
    { name: "Dashboard", href: "/" },
    { 
      name: "Sales",
      href: "/sales",
    },
    {
      name: "Users",
      href: "/addemployee",
    },
    {
      name: "Users",
      href: "/users",
    },
    {
      name: "Recruiting",
      href: "/recruiting",
    },
    {
      name: "Reports",
      href: "/reports",
    },
    {name:"Manage User",
      href:"/edituser/:id",
    },
    {name:"Consultants",
      href:"/manage-employees",
    },
    {name:"Update Password",
      href:"/updatePassword",
    },
    {name:"Requirements",
      href:"/requirements",
    },
    {name:"Requirement Submissions",
      href:"/requirements",
    },
    {name:"Candidate Documents",
      href:"/candidates/:id/documents",
    },
  ];

  const getPageTitle = () => {
    const matchedPage = AdminNavigation.find(
      (item) => item.href === location.pathname
    );

    if (matchedPage) {
      return matchedPage.name;
    }

    if (location.pathname.startsWith("/edituser/")) {
      return "Users";
    }
    
    if (location.pathname.startsWith("/manage-employees/")) {
      return "Consultants";
    }

    if (location.pathname.startsWith("/reports/")) {
      return "Reports";
    }

    if (location.pathname === "/requirements") {
      return "Requirements";
    }

    if (/^\/requirements\/[^/]+$/.test(location.pathname)) {
      return "Requirement Submissions";
    }

    if (location.pathname === "/candidates") {
      return "Candidates";
    }

    if (/^\/candidates\/[^/]+\/documents$/.test(location.pathname)) {
      return "Candidate Documents";
    }

    if (location.pathname.startsWith("/candidates/add")) {
      return "Add Candidate";
    }

    if (location.pathname.startsWith("/candidates/edit/")) {
      return "Edit Candidate";
    }

    return "Profile"; // Fallback title if no match is found
  };
  
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure you want to Logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3674B5",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout!",
      backdrop: `rgba(0, 0, 0, 0.5)`,
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        window.location.reload();
      }
    });
  };

  // Handle navigation on clicking dropdown options
  const handleNavigation = (path) => {
    if (path === "logout") {
      handleLogout();
    } else {
      navigate(path);
      setDropdownOpen(false);
    }
  };

  const handleDropdown = () => {};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="h-16 bg-white border-b border-slate-200 shadow-sm relative z-50">
      <div className="h-full px-6 flex items-center justify-between mx-auto">
        <div className="flex items-center">
          <button 
            onClick={toggleSidebar}
            className="lg:hidden bg-transparent border-none cursor-pointer p-2 mr-4 flex items-center justify-center rounded-md transition-colors hover:bg-slate-100"
            title={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
          >
            {isExpanded ? (
              <MenuIcon className="h-5 w-5 text-gray-500" />
            ) : (
              <MenuIcon className="h-5 w-5 text-gray-500" />
            )}
          </button>
          
          <h1 className="text-xl font-semibold text-gray-900">
            {getPageTitle()}
          </h1>
        </div>
        
        <div className="flex items-center gap-4">
          <div className="flex items-center space-x-1 sm:space-x-3">
            <button className="p-2 text-gray-500 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <HelpCircle className="h-5 w-5" />
            </button>
            
            <button className="p-2 text-gray-500 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <MessageSquare className="h-5 w-5" />
            </button>
            
            <button className="p-2 text-gray-500 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 relative">
              <Bell className="h-5 w-5" />
              <span className="absolute top-1 right-1 block h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"></span>
            </button>
            
            <div className="border-l border-gray-200 h-6 mx-1 sm:mx-3"></div>
          </div>
          
          <button 
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="border-none cursor-pointer w-10 h-10 rounded-full shadow-sm transition-all hover:-translate-y-0.5 p-0 overflow-hidden"
          >
            <img 
              src={getProfilePhoto().src}
              alt="Profile" 
              className="h-8 w-8 rounded-full"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = getProfilePhoto().fallback;
              }}
            />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {dropdownOpen && (
          <motion.div
            ref={profileRef}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute top-16 right-6 w-[280px] bg-white rounded-lg shadow-lg overflow-hidden z-50"
          >
            <div className="flex items-center p-4">
              <div className="w-10 h-10 rounded-full overflow-hidden mr-3">
                <img 
                  src={getProfilePhoto().src}
                  alt="Profile"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = getProfilePhoto().fallback;
                  }}
                />
              </div>
              <div className="overflow-hidden">
                <p className="text-sm font-medium text-slate-800 truncate">{`${currentUserDetails?.firstName} ${currentUserDetails?.lastName}`}</p>
                <p className="text-xs text-slate-500 truncate">{currentUserDetails?.email}</p>
              </div>
            </div>
            <div className="h-px bg-slate-200"></div>
            
            {menu?.map((item, index) => (
              <button
                key={index}
                onClick={() => handleNavigation(item.path)}
                className={`w-full py-3 px-4 block text-left bg-transparent border-none text-sm ${
                  item.path === "logout" ? "text-red-500 hover:bg-red-50" : "text-slate-700 hover:bg-slate-50"
                } cursor-pointer transition-all`}
              >
                <span className="flex items-center gap-3">
                  {item.icon}
                  {item.name}
                </span>
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Header;